import JumpMenu from './JumpMenu';
import Gallery from './PhotoGallery';
import Overview from './CommunitiesOverview';
import Blocks from './CommunitiesBlocksConfig';
import Resources from './CommunitiesResources';

export default class Communities {
  constructor() {
    // Use the imported blocks config.
    this.blocks = Blocks;
    this.addOverviewFunctionality();
    this.addGalleryFunctionality();
    this.addJumpLinks();
    this.addJumpMenu();
    this.addTeaserVideo();
  }

  addOverviewFunctionality() {
    const element = document.querySelector(this.blocks.overview);
    if (element && !element.Overview) {
      element.Overview = new Overview(element);
    }
  }

  addGalleryFunctionality() {
    const element = document.querySelector(this.blocks.gallery);
    if (element && !element.Gallery && !element.classList.contains('placeholder-block')) {
      element.Gallery = new Gallery(element);
    }
  }

  addJumpLinks() {
    this.blocks.complementary.forEach((obj) => {
      // Find the block.
      const block = document.querySelector(`#${obj.id}`);
      if (block) {
        // Get reference to block title, if it exists within this block.
        const title = block.querySelector('.block-title');

        // If the title was found and isn't empty, use that as the jumpmenu label.
        if (title && title.textContent.length) {
          obj.label = title.textContent;
        }

        // Add our jumplink to this block displaying the title text we set.
        JumpMenu.addJumpLink(obj);
      }
    });
  }

  addJumpMenu() {
    // Initialize our jumpmenu
    this.jumpmenu = document.querySelector('.jumpmenu');
    if (this.jumpmenu) {
      JumpMenu.init(this.jumpmenu);
    }
  }

  addTeaserVideo() {
    // Enables video to be opened in modal from teaser
    const element = document.querySelector(this.blocks.resources);
    if (element && !element.Resources) {
      element.Resources = new Resources(element);
    }
  }
}
